// extracted by mini-css-extract-plugin
export default {"projectProgression":"projectProgress_projectProgression__Y-mQW"};